import { inject, Pipe, PipeTransform } from '@angular/core';
import { Store } from '@softline/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { StationStore } from '../store';
import { SOFTLINE_FEATURE_TRANSPORTAUFTRAG_STATIONEN } from '../transport.shared';
import { KopfauBean } from '../types/kopfau-bean';

@Pipe({
  name: 'stationChanged',
  pure: true,
})
export class StationChangedPipe implements PipeTransform {
  private readonly store = inject(Store);

  transform(value: KopfauBean): Observable<boolean> {
    return this.store
      .observe(
        SOFTLINE_FEATURE_TRANSPORTAUFTRAG_STATIONEN,
        StationStore.getters.change,
        value.id
      )
      .pipe(map((o) => !!o));
  }
}
